import * as THREE from 'three';
import { Character } from '../Character';

export class CharacterAnimationManager {
    public static readonly tposeDiagnostic = false; // Set true to freeze characters in T-pose

    private readonly character: Character;
    private aimingSettings = {offSet: 1.64, amplitude: 2.49};
    public mixer: THREE.AnimationMixer;
    public animations: THREE.AnimationClip[];

    constructor(character: Character) {
        this.character = character;
    }

    setAnimations(animations: THREE.AnimationClip[]): void {
        if (CharacterAnimationManager.tposeDiagnostic) { return; }
        // Strip head-bone rotation tracks so HeadLookAt owns that bone exclusively.
        // Without this the mixer overwrites HeadLookAt's output every frame, causing snaps.
        this.animations = animations.map(clip => {
            const filtered = clip.tracks.filter(t => !/(?:^|\.)Head\.quaternion$/.test(t.name));
            if (filtered.length === clip.tracks.length) { return clip; }
            const stripped = clip.clone();
            stripped.tracks = filtered;
            return stripped;
        });

    }

    initMixer(gtlf: any): void {
        this.mixer = new THREE.AnimationMixer(gtlf.scene);
    }

    // @deprecated
    updateAimAnimation(clipName: string, cameraRotation, vector): void {
        if (this.mixer !== undefined) {
            const clip = THREE.AnimationClip.findByName(this.animations, clipName);
            const action = this.mixer.clipAction(clip);
            // pitch UP max: 2 - pitch DOWN min: 0
            action.time = (cameraRotation.getWorldDirection(vector).y + this.aimingSettings.offSet) / this.aimingSettings.amplitude;
            action.paused = true;
            action.stopWarping();
        }
    }

    setAnimation(clipName: string, fadeIn: number, runOnlyOnce?: boolean, lockWhenFinished?: boolean): number {
        if (this.mixer !== undefined) {
            // gltf
            const clip = THREE.AnimationClip.findByName(this.animations, clipName);

            const action = this.mixer.clipAction(clip);
            if (action === null) {
                console.error(`Animation ${clipName} not found!`);
                return 0;
            }
            if (runOnlyOnce) {
                action.setLoop(THREE.LoopOnce, 1);
            }
            if (lockWhenFinished) {
                action.clampWhenFinished = true;
            }
            this.mixer.stopAllAction();
            action.fadeIn(fadeIn);
            action.play();
            return action.getClip().duration;
        }
    }
}
